export default function R_Booleans() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Booleans Component</h1>
      <p>This is the R_Booleans tutorial section.</p>
    </div>
  );
}
